const DateFormats = {
  ISO_8601_DATE_FORMAT: 'YYYY-MM-DD',
};

export default DateFormats;
